import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from 'antd';

import './EmployeeRolesView.style.less';

class EmployeeRolesView extends PureComponent {
  getDataSource = scopes => {
    const results = [];
    for (let i = 0; i < scopes.length; i += 1) {
      const currentScope = scopes[i];
      const [scopeName, scopePermission] = currentScope.split(':');

      const existingNameIndex = results.findIndex(x => x.name === scopeName);
      if (existingNameIndex > -1) {
        results[existingNameIndex][scopePermission] = true;
      } else {
        const newScope = {
          name: scopeName,
          create: false,
          read: false,
          update: false,
          delete: false,
        };

        newScope[scopePermission] = true;

        results.push(newScope);
      }
    }

    return results;
  };

  render() {
    const { employeeRoles, placeholder } = this.props;
    let dataSource = [];
    const divItems = [];

    const checkedEmployeeRoles = employeeRoles.filter(x => x.checked);
    if (checkedEmployeeRoles.length > 0) {
      let allScopes = [];
      checkedEmployeeRoles.forEach(x => {
        allScopes = [...allScopes, ...x.module.scopes];
      });
      dataSource = this.getDataSource(allScopes);

      let index = 0;
      dataSource.forEach(x => {
        const key = `roles-view-${index}`;
        divItems.push(
          <div className="content-row" key={key}>
            <div className="role-name">{x.name}</div>
            <div className="role-permission">
              <Checkbox checked={x.create} disabled />
            </div>
            <div className="role-permission">
              <Checkbox checked={x.read} disabled />
            </div>
            <div className="role-permission">
              <Checkbox checked={x.update} disabled />
            </div>
            <div className="role-permission">
              <Checkbox checked={x.delete} disabled />
            </div>
          </div>,
        );

        index += 1;
      });
    }

    return (
      <div id="company-roles-view">
        <div className="title-row">
          <div className="title-col-submodule">Sub Module Permission</div>
          <div className="title-col-permission">
            <div className="title-row-permission">Permission</div>
            <div className="title-row-role">
              <div className="title-col-role border-right">Create</div>
              <div className="title-col-role border-right">Read</div>
              <div className="title-col-role border-right">Update</div>
              <div className="title-col-role">Delete</div>
            </div>
          </div>
        </div>
        {dataSource.length === 0 ? (
          <div className="content-items">
            <div className="content-row placeholder">{placeholder}</div>
          </div>
        ) : (
          <div className="content-items">{divItems}</div>
        )}
      </div>
    );
  }
}

EmployeeRolesView.propTypes = {
  employeeRoles: PropTypes.array,
  placeholder: PropTypes.string,
};

EmployeeRolesView.defaultProps = {
  placeholder: 'No Data',
};

export default EmployeeRolesView;
